export {useSearchAutocomplete, type SearchAutocompleteProps, type AriaSearchAutocompleteProps, type AriaSearchAutocompleteOptions, type SearchAutocompleteAria} from '../../../src/autocomplete/useSearchAutocomplete';
